import { motion, useReducedMotion } from 'motion/react';
import type { ReactNode, HTMLAttributes } from 'react';

type PressableProps = {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
  scale?: number;
  opacity?: number;
  as?: 'button' | 'div';
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  onHoverStart?: () => void;
  onHoverEnd?: () => void;
} & Omit<HTMLAttributes<HTMLElement>, 'onClick' | 'className' | 'onDrag' | 'onDragStart' | 'onDragEnd' | 'onAnimationStart'>;

export default function Pressable({
  children,
  className = '',
  onClick,
  scale = 0.96,
  opacity = 0.7,
  as: Tag = 'button',
  disabled,
  type = 'button',
  ...rest
}: PressableProps) {
  const reducedMotion = useReducedMotion();
  const MotionTag = Tag === 'button' ? motion.button : motion.div;

  return (
    <MotionTag
      {...rest}
      onClick={onClick}
      disabled={disabled}
      type={Tag === 'button' ? type : undefined}
      className={className}
      whileTap={reducedMotion ? undefined : { scale, opacity }}
      whileHover={reducedMotion ? undefined : { scale: disabled ? undefined : 1.01 }}
      transition={{ type: 'spring', stiffness: 500, damping: 22 }}
    >
      {children}
    </MotionTag>
  );
}